import { RouteObject } from 'react-router'
import membersRoutes from './members/routes'
import quickTeamsRoute from './quickTeams/routes'
import securityRoutes from './security/routes'
import staffRoutes from './staff/routes'
import teamsRoutes from './teams/routes'
import hrisIntegrationRoutes from './hrisIntegration/routes'
import delegationRoutes from './delegation/routes'

const routes: RouteObject[] = [
  ...membersRoutes,
  ...staffRoutes,
  ...securityRoutes,
  ...teamsRoutes,
  ...quickTeamsRoute,
  ...hrisIntegrationRoutes,
  ...delegationRoutes,
]

export default routes
